const BASE_URL = "https://online-movie-booking-backend-production.up.railway.app/api";

export default BASE_URL;
